import { Row, Col, Form, Button, Modal  } from 'react-bootstrap';
import "./SignatureOrderModal.css"
import {  useState, useRef } from 'react';
import SignaturePadComponent from './SignaturePadComponent';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch  } from "@fortawesome/free-solid-svg-icons";

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const SignatureOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    const [objOrder, setObjOrder] = useState([]);

    const [aclaracion, setAclaracion] = useState("");
    const [DNI, setDNI] = useState("");


    const [buttonWaiting, setButtonWaiting] = useState(false);

    const requestOrderInfo = async () =>{

        const endpoint = "getOrderByID?order_id=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();

        const metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);

    } //END FUNCTION

    const saveCustomerSignature = async () => {


        //GET SIGNATURE IMAGE
        let imageData;
        if (signaturePadRef.current) {
            imageData = await signaturePadRef.current.getImage(); // Llamamos la función del hijo
        }

        //MAIN VALIDATION
        if(!aclaracion || !DNI || imageData.length < 2150){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        //DATOS MINIMOS
        if(DNI.length < 8) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo DNI debe tener 8 dígitos.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        //DNI ONLY ALLOWS PERIODS OR NUMBERS
        


        if(aclaracion.length < 8) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo Aclaración debe tener mínimo 8 caracteres.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }

        //GRAPHICS EFFECT
        setButtonWaiting(true);

        let endpoint = "updateOrder?orderID=" + orderID;

         //
        const metadata = {
            "customer": objOrder.customer,
            "model": objOrder.model,
            "serialNumber":objOrder.serialNumber,
            "failure":objOrder.failure,
            "personContact":objOrder.personContact,
            "issuesDate": objOrder.issuesDate,
            "status": "Solicitud finalizada",
            "address": objOrder.address,
            "tecnico": objOrder.tecnico,
            "technicalReport": objOrder.technicalReport,
            "counterDevice": objOrder.counterDevice,
            "serviceInvoice": objOrder.serviceInvoice,
            "customerSignature": imageData,
            "signerName": aclaracion.replace(/[\t\\']/g, '').trim(),
            "signerDNI": DNI.replace(/[\t\\']/g, '').trim(),
            "personContactData": objOrder.personContactData,
            "serviceType": objOrder.serviceType,
            "notes":objOrder.notes
        };

        //
        let requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";

        //
        let response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        
        //STORE LOG INFORMATION
        storeOrderLog(orderID, sessionUser.customer_name, "Servicio Firmado por el Cliente", "");




        ///
        ///BUILD PDF
        ///

        if(objOrder.serviceInvoice == "Si") {

            //FILL TEMPLATE
            requestBody = {
                "templateName":"service_template.html",
                "values":[
                    {
                        "fieldName":"##ORDER_ID",
                        "fieldValue": "" + orderID + ""
                    },
                    {
                        "fieldName":"##SD_0",
                        "fieldValue": "" + metadata.customer + ""
                    },
                    {
                        "fieldName":"##SD_1",
                        "fieldValue": "" + metadata.model + ""
                    },
                    {
                        "fieldName":"##SD_2",
                        "fieldValue": "" + metadata.serialNumber + ""
                    },
                    {
                        "fieldName":"##SD_3",
                        "fieldValue": "" + metadata.failure + ""
                    },
                    {
                        "fieldName":"##SD_4",
                        "fieldValue": "" + metadata.personContact + ""
                    },
                    {
                        "fieldName":"##SD_5",
                        "fieldValue": "" + metadata.tecnico + ""
                    },
                    {
                        "fieldName":"##SD_6",
                        "fieldValue": "" + metadata.address + ""
                    },
                    {
                        "fieldName":"##SD_7",
                        "fieldValue": "" + metadata.issuesDate + ""
                    },
                    {
                        "fieldName":"##TEC_REPORT",
                        "fieldValue": "" + metadata.technicalReport + ""
                    },
                    {
                        "fieldName":"##CUSTOMER_SIGNATURE",
                        "fieldValue": "<img style='height: 100px' src='" + metadata.customerSignature + "' alt:'firma' />"
                    },
                    {
                        "fieldName":"##ACLARACION",
                        "fieldValue": "" + metadata.signerName + ""
                    },
                    {
                        "fieldName":"##DNI",
                        "fieldValue": "" + metadata.signerDNI + ""
                    },
                    {
                        "fieldName":"##DEVICE_COUNTER",
                        "fieldValue": "" + metadata.counterDevice + ""
                    },
                    {
                        "fieldName":"##SERVICE_TYPE",
                        "fieldValue": "" + metadata.serviceType + ""
                    }
                ]
            };

            endpoint = "FillTemplate"

            response = await fetch(apiUrl + endpoint,
            {
                method: "POST",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                body: JSON.stringify(requestBody)
            });


            let responseContent = await response.json();

            //RENDER PDF
            requestBody = {
                "html":"" + responseContent.templateString + "",
                "margins":"0",
                "return_method":"link"
            };

            endpoint = "convertHTML2PDF"

            response = await fetch(apiUrl + endpoint,
            {
                method: "POST",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                body: JSON.stringify(requestBody)
            });

            //
            responseContent = await response.json();


            if (responseContent.pdF_Link) {

                //SEND MAIL
                let htmlBody = "<html> A continuación, se adjunta servicio completado para su facturación<br /><br />";
                htmlBody = htmlBody + "<b>Cliente:</b> " + objOrder.customer + "<br />";
                htmlBody = htmlBody + "<b>Número de Servicio:</b> " + orderID + "<br />";
                htmlBody = htmlBody + "<b>Número de Serie del Equipo:</b> " + objOrder.serialNumber + "<br />";
                htmlBody = htmlBody + "<b>Contador:</b> " + objOrder.counterDevice + "<br /><br />";
                htmlBody = htmlBody + "Saludos cordiales </html>";

                //OBJECT ATTACHMENT
                let fileAttachmentObject = {
                    "attachmentName": "Informe_Servicio",
                    "attachmentLink": responseContent.pdF_Link
                }


                requestBody = {
                    //
                    "emailReceipt": "administracion@quatrosoluciones.com.ar",
                    "emailSubject": "Notificación de Facturación",
                    "bodyHTML": htmlBody,
                    "filesAttachments": [fileAttachmentObject]
                };

                endpoint = "SendMail_SMTP"

                response = await fetch(apiUrl + endpoint,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                    body: JSON.stringify(requestBody)
                });


            } //

        } //END IF BUILD PDF - SEND EMAIL


        //RESTORE BUTTON
        setButtonWaiting(false);

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //CLOSE MODAL
        requestClose(false);

    } //END FUNCTION

    const signaturePadRef = useRef(null);

    return (
        <>
        <Modal show={show} onShow={requestOrderInfo} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Firmar Orden de Servicio | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                
                <Row>
                    <Col xs={12} style={{lineHeight: '20px'}}>
                        
                        <span className='closeOrderlabels'>Cliente: </span>
                        <span>{objOrder.customer} </span><br />
                        
                        <span className='closeOrderlabels'>Modelo: </span>
                        <span>{objOrder.model} </span><br />

                        <span className='closeOrderlabels'>N° Serie: </span>
                        <span>{objOrder.serialNumber}</span><br />

                        <span className='closeOrderlabels'>Falla / Detalles: </span>
                        <span>{objOrder.failure}</span><br />

                        <span className='closeOrderlabels'>Persona Contacto: </span>
                        <span>{objOrder.personContact}</span><br />

                        <span className='closeOrderlabels'>Dirección del servicio: </span>
                        <span>{objOrder.address}</span><br />

                        <span className='closeOrderlabels'>Datos de Contacto: </span>
                        <span>{objOrder.personContactData}</span><br />

                        <span className='closeOrderlabels'>Servicio Facturable: </span>
                        <span>{objOrder.serviceInvoice}</span><br />

                        <span className='closeOrderlabels'>Notas / Observaciones: </span>
                        <span>{objOrder.notes}</span><br />

                        <span className='closeOrderlabels'>Técnico: </span>
                        <span>{objOrder.tecnico}</span><br /><br />

                    </Col>
                    
                    {objOrder.technicalReport ? (
                        <div>
                            <hr />
                            <Col xs={12}>
                                <Form.Group>
                                    <Form.Label className={'newOrderlabels'}>Informe Técnico</Form.Label>
                                    <Form.Control as="textarea" rows={5} disabled>{objOrder.technicalReport}</Form.Control><br />
                                </Form.Group>
                            </Col>
                            <Row>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Contador Equipo</Form.Label>
                                        <Form.Control type="text" disabled value={objOrder.counterDevice} /><br />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Tipo de Servicio</Form.Label>
                                    <Form.Control type="text" disabled value={objOrder.serviceType} /><br />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>
                    ) : ""}

                    <Col xs={12}>
                        <Form.Label className={'newOrderlabels'}>Firma del Cliente</Form.Label>
                        <SignaturePadComponent ref = {signaturePadRef} />
                        <br />

                        <Row>
                            <Col xs={6}>
                                <Form.Group> 
                                    <Form.Label className={'newOrderlabels'}>Aclaración</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Aclaración" 
                                        onChange={(event)=> setAclaracion(event.target.value)} />
                                </Form.Group>
                            </Col>
                            
                            <Col xs={6}>
                                <Form.Group>
                                <Form.Label className={'newOrderlabels'}>DNI</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="DNI" 
                                    onChange={(event)=> setDNI(event.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>     
                    </Col>
            </Row>     
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={saveCustomerSignature}
                >
                { buttonWaiting ? (
                        <>
                            Por favor espere... 
                            <FontAwesomeIcon 
                                icon={faCircleNotch} 
                                spin
                            />
                        </>
                ) : (
                    "Guardar Datos"
                )}
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default SignatureOrderModal;